module.exports = __webpack_public_path__ + "static/media/Corn2V3-V5.d9355154.png";